export function getId() {
  const url = window.location.href
  const url_params = url.split('/')
  return url_params[url_params.length - 1]
}
